import { useMemo } from 'react'
import cx from 'classnames'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import { ImageType } from '../types'
import { useTranslations } from 'common/language'
import { BlockSectionTitle, BlockWrapper, Container, ImageBlock, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


ImageGridPortrait.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      image: ImageType,
      heading: PropTypes.string,
      text: PropTypes.string,
      rating: PropTypes.number,
      cta_link: PropTypes.string,
    })),
    cta_link_caption: PropTypes.string,
  }),
}

export default function ImageGridPortrait({
  data = {
    items: [],
  },
}) {
  const { gettext } = useTranslations()
  const options = useMemo(() => get(data, 'items', []).map(({ rating, ...option }, idx) => (
    <div
      key={idx + option.heading}
      className={classNames.column}
    >
      <ImageBlock
        {...option}
        cta={data.cta_link_caption}
        className={classNames.image}
      >
        {rating && (
          <div className={classNames.scoreContainer}>
            <Typography
              variant="h2"
              tag="div"
              color="white"
              className={cx(classNames.noMargin, classNames.scoreTitle)}
            >
              {rating ? rating.toFixed(1) : 0}
            </Typography>
            <Typography
              variant="content"
              color="white"
              className={classNames.noMargin}
            >
              {gettext('von')} 5
            </Typography>
          </div>
        )}
      </ImageBlock>
    </div>
  )), [data.items])

  return (
    <BlockWrapper>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        <div className={classNames.imageGridPortrait}>{options}</div>
      </Container>
    </BlockWrapper>
  )
}
